import { v4 as uuidv4 } from "uuid";
const bffApiUrl = process.env.NEXT_PUBLIC_BACKEND_URL ?? "";

export const fetchOptionList = async (idResa: string) => {
  const requestHeaders: HeadersInit = new Headers();
  requestHeaders.append("x-request-id", uuidv4());
  requestHeaders.append("x-api-key", process.env.NEXT_PUBLIC_BFF_API_KEY ?? "");
  requestHeaders.append("Accept", "application/json");

  const response = await fetch(
    `${bffApiUrl}/bookings/v1/getAvailableOptions/${idResa}`,
    {
      method: "GET",
      headers: requestHeaders,
    }
  );

  if (!response.ok) {
    throw {
      status: response.status,
      body: (await response.json()) as string,
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return response.json();
};

export type ActiveOption = {
  id: string;
  quantity: number;
  duration: string | null;
  unitPrice: number;
  totalPrice: number;
};
export const fetchActiveOptions = async (
  resaId: string
): Promise<ActiveOption[]> => {
  const requestHeaders: HeadersInit = new Headers();
  requestHeaders.append("x-request-id", uuidv4());
  requestHeaders.append("x-api-key", process.env.NEXT_PUBLIC_BFF_API_KEY ?? "");
  requestHeaders.append("Accept", "application/json");

  const response = await fetch(
    `${bffApiUrl}/bookings/v1/getBookingOptions/${resaId}`,
    {
      method: "GET",
      headers: requestHeaders,
    }
  );

  if (!response.ok) {
    throw {
      status: response.status,
      body: (await response.json()) as string,
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return response.json();
};

export type NewOption = {
  id: string;
  quantity: number;
};

export const fetchOptionCacheId = async (
  bookingId: string,
  firstname: string,
  lastname: string,
  email: string,
  additionalOptions: NewOption[]
): Promise<string> => {
  const response = await fetch(
    `${bffApiUrl}/bookings/v1/payment/addOptions/createCacheId`,
    {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        bookingId: bookingId,
        firstname: firstname,
        lastname: lastname,
        email: email,
        additionalOptions: additionalOptions,
      }),
    }
  );

  if (!response.ok) {
    throw {
      status: response.status,
      body: (await response.json()) as string,
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return response.json();
};

export const fetchAddBookingOptions = async (
  bookingId: string,
  additionalOptions: NewOption[]
): Promise<string> => {
  const response = await fetch(`${bffApiUrl}/bookings/v1/addOptions`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      bookingId: bookingId,
      additionalOptions: additionalOptions,
    }),
  });

  if (!response.ok) {
    throw {
      status: response.status,
      body: (await response.json()) as string,
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return response.text();
};
